import React, { useContext } from 'react';
import { Modal } from 'antd';
import AccountingDetailsContext from '../../../contexts/accounting-context/AccountingDetailsContext';
import AccountingDetailsModalForm from './TransactionsDetailsModalForm';
import { useParams } from 'react-router-dom';
// import AccountingForm from '../accounting-tree-page/AccountingForm';
import { getLeafType } from '../../../custom-hooks/getLeafType';
import ViewTransaction from './ViewTransaction';
import TransactionsContext from '../../../contexts/accounting-context/TransactionsContext';

const TransactionsDetailsModal = () => {
  const {
    modalOpened,
    setModalOpened,
    setSelectedTransactions,
    selectedAccounting
  } = useContext(TransactionsContext);

  const params = useParams();
  let typeOfAccount = getLeafType(params.id);

  return (
    <Modal
      transitionName=""
      className="work-places-modal shared-custom-modal"
      width="90%"
      style={{ maxWidth: '850px' }}
      title={'عرض تفاصيل المعامله'}
      visible={modalOpened}
      onOk={() => {
        setModalOpened(false);
        setSelectedTransactions(null);
      }}
      onCancel={() => {
        setModalOpened(false);
        setSelectedTransactions(null);
      }}
      footer={false}
    >
      <ViewTransaction />
    </Modal>
  );
};

export default TransactionsDetailsModal;
